import { render, staticRenderFns } from "./UsersAddNew.vue?vue&type=template&id=24346fe8&"
import script from "./UsersAddNew.vue?vue&type=script&lang=js&"
export * from "./UsersAddNew.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports